import { isPreviewHost } from '../../../constants/landingHosts';
import { LANDING_PAGES, LANDING_PRIMARY_HOST } from './landingRegistry';

export const normalizeLandingPath = (pathname = '/') => (String(pathname).split(/[?#]/)[0].replace(/\/+$/, '') || '/');

export function resolveLandingRoute({ hostname = '', pathname = '/' } = {}, entries = LANDING_PAGES) {
  const host = String(hostname).toLowerCase().replace(/\.$/, '');
  const path = normalizeLandingPath(pathname);
  const previewHost = isPreviewHost(host);
  const landing = entries.find((entry) => (
    ((entry.host ? host === entry.host : host === LANDING_PRIMARY_HOST) && path === entry.path)
    || (previewHost && (path === entry.previewPath || (!entry.host && path === entry.path)))
  ));
  if (!landing) return null;
  return { landing, preview: previewHost || path === landing.previewPath };
}
